import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'
import { EventEmitter, Injectable } from '@angular/core'
import { environment } from 'src/environments/environment'
import { AccountModel, IAsaasAccountStatus, ParamsConfig } from './account'
import { MunicipalService } from './account-detail/commercial-information/services-data/services.component'
import { IAccountOnboarding } from './account'

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  private accountList$: Observable<any> | null = null
  public accountListEventEmmiter: EventEmitter<any> =
    new EventEmitter()
  public accountToEdit: any = {} 



  constructor(
    private httpClient: HttpClient
    ) {}



  public clearCacheAccountList(): void {
    this.accountList$ = null
    this.getAllAccounts({
      page: 1,
      page_size: 10,
      term: '',
      ativo: 'true',
      filter: []
    })
  }

  public getAllAccounts(objParams?:ParamsConfig): void {

    if(objParams) {

      let params = new HttpParams()
      .set('page', objParams.page)
      .set('page_size', objParams.page_size)
      .set('term', objParams.term)
      .set('ativo', objParams.ativo || '')
      .set('tags', objParams.filter?.join(",") || '');

      if (objParams.ativo && objParams.ativo !== "all") {
        params = params.set("ativo", objParams.ativo.toString());
      }

      if (objParams.tipo && objParams.tipo !== "all") {
        params = params.set("tipo", objParams.tipo.toString());
      }
      
      if (objParams.orderBy) {
        params = params.set('orderBy', objParams.orderBy);
      }
      if (objParams.orderDir) {
        params = params.set('orderDir', objParams.orderDir);
      }

      this.accountList$ = this.httpClient
        .get<any>(environment.apiUrl + '/admin/contas', {params})


    }else{

      const params = {
        page: 1,
        page_size: 10
      }

      this.accountList$ = this.httpClient
        .get<any>(environment.apiUrl + '/admin/contas', {params})

    }


    this.accountList$.subscribe((data) => {
      this.accountListEventEmmiter.emit(data)
    })
  }


  public getAccount(id: number) {

    return this.httpClient
        .get<any>(environment.apiUrl + '/admin/'+id);
  }


  public deleteAccount(id: string) {
    return this.httpClient.delete<any>(
        environment.apiUrl + '/admin/' + id
    )
  }

  public toggleAccountActivation(id: number, action:string) {
    return this.httpClient.put<any>(
        environment.apiUrl + '/admin/toggle-activation/' + id, {action}
    )
  }

  public setOonIntegration(id: number, enabled: boolean) {
    return this.httpClient.put<AccountModel>(
        environment.apiUrl + '/admin/contas/' + id + '/oon-integration', {enabled}
    )
  }

  public setModoSimplificado(id: number, enabled: boolean) {
    return this.httpClient.put<AccountModel>(
        environment.apiUrl + '/admin/contas/' + id + '/modo-simplificado', {enabled}
    )
  }

  public saveNewAccount(account: AccountModel) {
    return this.httpClient.post<AccountModel>(
      environment.apiUrl + '/admin/contas',
      account
    )
  }

  public editAccount(account: AccountModel, idAccount: string) {
    return this.httpClient.put<AccountModel>(
      environment.apiUrl + '/admin/' + idAccount,
      account
    )
  }

  public getCustomerBankAccount(id: any): Observable<any> {
    return  this.httpClient.get<any>(environment.apiUrl + '/admin/banco/' + id)
  }

  public updateCustomerBankAccount(id: any, bankModel:any): Observable<any> {
    return  this.httpClient.put<any>(environment.apiUrl + '/admin/banco/' + id, bankModel )
  }  

  public getUsersList(id: number) {

    return this.httpClient
        .get<any>(environment.apiUrl + '/admin/usuarios/'+id);
        
  }


  saveNewUser(user:any){
    return this.httpClient
    .post<any>(environment.apiUrl + '/admin/user', user);
  }

  editUser(userModel:any, id:number) {
    return this.httpClient
    .put<any>(environment.apiUrl + '/admin/user/'+id, userModel);
  }
  
  deleteUser(id: number) {
    return this.httpClient.delete<any>(
        environment.apiUrl + '/admin/user/'+id)

  }

  getMunicipalServicesOptions(AccountId:any): Observable<any>  {
    return this.httpClient
        .get<any>(environment.apiUrl + '/admin/options-services/'+AccountId )
  }

  getTaxInformations(AccountId:any): Observable<any>  {
    return this.httpClient
        .get<any>(environment.apiUrl + '/admin/tax-information/'+AccountId )
  }

  updateTaxInformations(accountId:any, bodyReq:any): Observable<any>  {
    return this.httpClient
        .post<any>(environment.apiUrl + '/admin/tax-information/'+accountId, bodyReq)
  }

  getVisualIdentityInfo(id:any){
    return this.httpClient
    .get<any>(environment.apiUrl + '/admin/visual-info/'+id, );
  }

  saveVisualIdentitySettings(settings:any, id:any){
    return this.httpClient
    .post<any>(environment.apiUrl + '/admin/visual-identity/'+id, settings);
  }

  getVisualIdentitySettings(id:any){
    return this.httpClient
    .get<any>(environment.apiUrl + '/admin/visual-identity/'+id);
  }

  public saveNewAccountService(service: MunicipalService) {
    return this.httpClient.post<any>(
      environment.apiUrl + '/admin/services',
      service
    )
  }

  public removeAccountService(id: any) {
    return this.httpClient.delete<any>(
      environment.apiUrl + '/admin/services/'+id
    )
  }

  public getAccountServices(id:string) {
    return this.httpClient.get<any>(
      environment.apiUrl + '/admin/services/'+id
    )
  }

  public getServices (): any {
    return this.httpClient.get(environment.apiUrl + '/admin/services')
  }


  public onboardingAsaasAccount(idAccount: string): Observable<IAccountOnboarding> {
   return this.httpClient
   .get<IAccountOnboarding>(`${environment.apiUrl}/admin/onboarding-asaas/${idAccount}`) 
  }

  public asaasAccountStatus(idAccount: string): Observable<IAsaasAccountStatus> {
    return this.httpClient
    .get<IAsaasAccountStatus>(`${environment.apiUrl}/admin/asaas-account-status/${idAccount}`) 
   }

  public masterAccess(id:number) {
    return this.httpClient.get<any>(environment.apiUrl + '/admin/master_access/'+id)
  }

  
  public syncAccount (id: number,data: {user:string, pw: string}): any {
    return this.httpClient.post(environment.apiUrl + '/admin/sync/'+id, data)
  }


  public getSessionId(basic_token: string): void {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    });

    const body = {
      "basic_token": basic_token,
    }

    this.httpClient.post<{ jsessionid: string }>(`${environment.apiUrl}/trackings/jsessionid`, body, { headers })
      .subscribe({
        next: (response) => {
          document.cookie = `JSESSIONID=${response.jsessionid}; path=/; SameSite=None; Secure`;
        },
        error: (err) => {
          console.error('Erro ao obter JSESSIONID:', err);
        }
      });
  }

  public uploadLogo(file: File, accountId: any) {
    const formData = new FormData();
    formData.append('file', file);

    return this.httpClient.post(
      `${environment.apiUrl}/admin/account/${accountId}/upload-logo`,
      formData
    );
  }

  public getLogo(accountId: any): Observable<{ logo_base64: string }> {
    return this.httpClient.get<{ logo_base64: string }>(`${environment.apiUrl}/admin/account/${accountId}/logo`);
  }

  public removeLogo(accountId: any): Observable<any> {
    return this.httpClient.delete(`${environment.apiUrl}/admin/account/${accountId}/logo`);
  }

  public getIntegrationStatus(id: number) {
    return this.httpClient.get<any>(environment.apiUrl + '/admin/sync/status/' + id)
  }

  // Relatório: dispositivos por base (instalados HUDLY.Go vs online Traccar)
  public getDevicesPerBaseReport() {
    const headers = new HttpHeaders().set('X-Skip-Loader', 'true');
    return this.httpClient.get<any>(`${environment.apiUrl}/admin/contas/devices-active-count`, { headers });
  }
}
